// extracted by mini-css-extract-plugin
export default {"fullfiledAnswerBlock":"fullfiledAnswer_fullfiledAnswerBlock__uscgG","iconContainer":"fullfiledAnswer_iconContainer__6iPxo","text":"fullfiledAnswer_text__Spc6h"};